import { createFileRoute } from '@tanstack/react-router'
import { SEARCH_PARAM_EXPLORATION_ID } from 'routes/explorer/-searchParams'
import { z } from 'zod'

const drilldownExplorationSchema = z.object({
  [SEARCH_PARAM_EXPLORATION_ID]: z.string().optional(),
})
export const Route = createFileRoute('/drilldown-exploration/$siteID')({
  component: RouteComponent,
  staticData: {
    title: 'Drilldown Exploration',
  },
  validateSearch: drilldownExplorationSchema,
})

function RouteComponent() {
  return <div>Hello &quot;drilldown-exploration&quot;!</div>
}
